// -----------------------------------------------------------------------------
// Smooth scroll
// -----------------------------------------------------------------------------

$(function () {

  if (window.location.hash) {
    var hash = window.location.hash;

    if ($(hash).length) {
      setTimeout(function() {
        $('html, body').stop().animate({
          scrollTop: $(hash).offset().top - 80
        }, 300);
      }, 300);
    }

    $(window).resize(function () {
      if (window.matchMedia('(max-width: 767px)').matches) {
        if ($(hash).length) {
          setTimeout(function() {
            $('html, body').stop().animate({
              scrollTop: $(hash).offset().top - 60
            }, 300);
          }, 400);
        }
      } else {
        if ($(hash).length) {
          setTimeout(function() {
            $('html, body').stop().animate({
              scrollTop: $(hash).offset().top - 80
            }, 300);
          }, 400);
        }
      }
    });
  }
  $(window).trigger('resize');

});